import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface DobPickerProps {
    value: Date | null;
    onChange: (date: Date | null) => void;
    error?: boolean;
}

export const DobDatePicker: React.FC<DobPickerProps> = ({
                                                            value,
                                                            onChange,
                                                            error,
                                                        }) => {
    return (
        <DatePicker
            selected={value}
            onChange={onChange}
            dateFormat="MM/dd/yyyy"
            maxDate={new Date()}               // 🚫 no future dates
            placeholderText="MM/DD/YYYY"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            className={`w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors ${
                error ? "border-red-500" : "border-slate-300"
            }`}
        />
    );
};

